<ng-container *transloco="let t; read:TRANSLATION_SCOPE">
  <rx-button buttonClass="trainline-green"
             [flexible]="true"
             icon="rx-right"
             iconPosition="right"
             data-qa="test-trainline-link-button"
             (onClick)="navigateToTrainline()">
    <div class="container">
      <div class="row justify-content-between">
        <div>
          <img [src]="'/assets/images/logos/trainline.svg'" alt="Trainline"/>
        </div>
        <div>
          {{ t('getTickets') }}
        </div>
      </div>
    </div>
  </rx-button>
</ng-container>
